module.exports = __webpack_public_path__ + "img/buddy_antenna-04.c171a067.svg";